import css from "./FlagToggle.module.css";

/**
 * Mini slide-switch for booking flags (34×18 track, 13×13 knob). Per
 * screen-03 эталон the 7 booking flags share the same neon switch shape;
 * the ON-state colour palette is the only thing that varies, and it's
 * driven by `tone`:
 *
 *   - "success"  → green       — Здтк / Класс / ДР / Учеб
 *   - "alert"    → red w/ glow — !!! (priority)
 *   - "rival"    → muted red   — КНКР (competition)
 *   - "special"  → gradient    — СпцВ (special event, purple→green)
 *
 * The эталон has NO other tones (no cyan/orange/pink). Don't add ad-hoc
 * variants — they don't exist in the design.
 */
export type FlagTone = "success" | "alert" | "rival" | "special";

export interface FlagToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  /** ON-state colour theme. Default "success" (green). */
  tone?: FlagTone;
  disabled?: boolean;
}

const TONE_CLASS: Record<FlagTone, string | undefined> = {
  success: css.toneSuccess,
  alert: css.toneAlert,
  rival: css.toneRival,
  special: css.toneSpecial,
};

export function FlagToggle({ checked, onChange, label, tone = "success", disabled }: FlagToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      className={`${css.flag} ${TONE_CLASS[tone]} ${checked ? css.on : ""}`}
      onClick={() => !disabled && onChange(!checked)}
    >
      <span className={css.dot} aria-hidden="true" />
      <span className={css.label}>{label}</span>
    </button>
  );
}
